<template>
  <vue-apex-charts
    class="comBarChart"
    ref="competitionChartBar"
    :height="barChartHeight"
    v-on:update:heightSetting="setHeight"
    :options="chartOptionsBar"
    :series="series"
  />
</template>

<script>
import VueApexCharts from "vue-apexcharts";

const colorMap = ["#3366cc", "#dc3912", "#ff9900", "#109618", "#990099", 
                  "#0099c6", "#dd4477", "#66aa00", "#b82e2e", "#316395", 
                  "#994499", "#22aa99", "#aaaa11", "#6633cc", "#e67300", 
                  "#8b0707", "#651067", "#329262", "#5574a6", "#3b3eac"];

export default {
  name: "CompetitionChartBar",
  components: {
    VueApexCharts,
  },
  data() {
    return {
      barChartHeight: 45*21,
      chartOptionsBar: {
        chart: {
          type: "bar",
          background: '#FBFBFB',
          toolbar:{
            show: false
          },
          sparkline:{
            enabled: true
          }
        },
        grid:{
          show: true,
        },
        dataLabels: {
          enabled: true,
          fontFamily: "NanumBarunGothic !important",
          textAnchor: 'start',
          offsetX: 0,
          style: {
            colors: ['#333'],
          },
          formatter: function (val, opt) {
            return opt.w.globals.labels[opt.dataPointIndex] + ":  " + Math.round(val) + "%"
          },
          dropShadow: {
            enabled: false
          },
        },
        stroke: {
          width: 1,
          colors: ['#fff']
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          labels: {
            show: false
          }
        },
        tooltip: {
          shared: true,
          followCursor: true,
          intersect: false,
          x: {
            show: true
          },
          y: {
            formatter(val){
              return val
            },
            title: {
              formatter: function () {
                return ''
              }
            },
          },
        },
        legend: {
          show: false,
          position: "top",
          horizontalAlign: "left",
          offsetX: 0,
          fontSize: "12px",
          fontFamily: "NanumBarunGothic !important",
          itemMargin: {
            horizontal: 5,
            vertical: 5,
          },
        },
        plotOptions: {
          bar: {
                barHeight: '80%',
                distributed: true,
                horizontal: true,
                dataLabels: {
                  position: 'bottom'
                },
              }
        },
        noData: {
          text: '분석중...',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: '#1817E7',
            fontSize: '20px',
            fontFamily: "NanumBarunGothic"
          }
        },
        colors: [
          function({ value, seriesIndex, w }) {
            if(w.globals.labels[seriesIndex] == 'NONBRANDED')
              return '#bfbfbf';
            else
              return '#A5BFFF';
          }
        ],
      },
      series: [{
        data: []
      }],
    };
  },
  props: {
    barChartData: {
      type: Array,
      default: () => [],
    },
    barChartFreq: {
      type: Array,
      default: () => [],
    },
    barChartCategory: {
      type: Array,
      default: () => [],
    },
    totalFreq: {
      type: Number,
      default: 0
    },
  },
  watch: {
    barChartData() {
      const newData = []
      for (const data of this.barChartData) {
        newData.push(data);
      }

      const newCategory = []
      for (const data of this.barChartCategory) {
          newCategory.push(data);
      }
      
      const barChartOption = {
        xaxis: {
          categories: newCategory,
        },
        series: [{
          data: newData
        }]
      };
      this.setHeight(45*newCategory.length)
      this.setValues(newData, newCategory, this.totalFreq, this.barChartFreq)
    },
  },

  methods:{
    setHeight(value) {
      this.barChartHeight = value
    },
    setValues(newData, newCategory, totalFreq, chartFreq){
      this.chartOptionsBar.xaxis = {
          categories: newCategory,
        }
      this.series = [{
          data: newData
        }]      
      this.chartOptionsBar.tooltip = {
        followCursor: true,
        enabled: true,
        fixed: {
          enabled: false,
        },
        x: {
          show: true
        },
        y: {
          formatter(val, d){
            return chartFreq[d.dataPointIndex].toLocaleString()
            // return Math.round((val / 100) * totalFreq).toLocaleString()
          },
          title: {
            formatter: function () {
              return ''
            }
          },
        },
      }
    }
  }
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/chart-apex.scss";

.comBarChart .apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-title {
  font-size: 12px !important;
  font-weight: 600;
}

.comBarChart .apexcharts-canvas .apexcharts-tooltip-text {
  font-family: NanumBarunGothic !important;
  font-weight: 400;
  font-size: 10px !important;
  filter: none;
}

.comBarChart .apexcharts-tooltip-marker {
  width: 8px;
  height: 8px;
  position: relative;
  top: 0px;
  margin-right: 5px;
  border-radius: 50%;
}
</style>
